import { createSlice } from "@reduxjs/toolkit";

const projectSlice = createSlice({
  name: "project",
  initialState: {
    projects: [],
    currentProjectId: null,
  },
  reducers: {
    setCurrentProjectId(state, action) {
      state.currentProjectId = action.payload;
    },
    setProjects(state, action) {
      state.projects = action.payload;
    },
    deleteProjects(state, action) {
      const projects = state.projects.filter((item) => item.id !== action.payload.id);
      state.projects = projects;
    }
  },
});

export default projectSlice.reducer;
export const { setCurrentProjectId, setProjects, deleteProjects } = projectSlice.actions;
